// extracted by mini-css-extract-plugin
export default {"logOut":"LogOut_logOut__PdYOO","icon":"LogOut_icon__eULAI"};